module.exports = __webpack_public_path__ + "static/media/login-background.ceb92de3.jpg";